import styled from 'styled-components'
import { H3, H5, Text } from '../../../../../../../../../../Styles/typography'
import { darkAccent } from '../../../../../../../../../../Styles/colors'
import {
  hFlex,
  square,
} from '../../../../../../../../../../Styles/style-helpers'

export const InfoEl = styled.div`
  margin-top: 2em;

  ${Text} {
    margin-bottom: 0.25em;
    text-transform: uppercase;
    color: ${darkAccent};
  }

  ${H3} {
    font-weight: bold;
  }

  .description {
    margin-top: 1em;
    line-height: 1.5;
  }

  ${H5} {
    margin-top: 2em;
  }

  .files {
    .file {
      margin: 1em 0;
      padding: 1em;
      box-shadow: 0 0 0.5em rgba(0, 0, 0, 0.1);
      max-width: 66%;
      ${hFlex};
      justify-content: flex-start;
      cursor: pointer;
      transition: background-color 150ms ease;

      &:hover {
        background-color: #e7e7e7;
      }

      &:active {
        background-color: #c7c7c7;
      }

      .icon {
        ${square('2em')};
      }

      p {
        margin-left: 0.5em;
      }
    }
  }
`
